import { isDateInRange } from 'ecs-react-components/dist/index.es';
/*
Append new string value to the array provided that its not duplicate or empty string.
*/
const merge = (arr, newStringValue) =>
  (arr && newStringValue
    && newStringValue.length > 0
    && arr.map((a) => a.toLowerCase())
      .indexOf(newStringValue.toLowerCase()) === -1 ?
    arr.concat(newStringValue) :
    arr);

const insensitiveCaseSort = (a, b) => (a ? a.localeCompare(b) : -1);

export const extractTestResultsFilterOptions = (results) => {
  const models = [];
  for (let i = 0; i < results.length; i += 1) {
    for (let j = 0; j < results[i].labResultGroups.length; j += 1) {
      models.push(results[i].labResultGroups[j].groupDisplayName);
    }
  }
  const newTestProcedureList = models.reduce((prevFilterOptions, currResult) =>
    merge(prevFilterOptions, currResult ?
      currResult.trim() : '').sort(insensitiveCaseSort), []);
  const newOrderedByList = results.reduce((prevFilterOptions, currResult) =>
    merge(prevFilterOptions, currResult.requestingPhysician ?
      currResult.requestingPhysician.trim() : '').sort(insensitiveCaseSort), []);
  return {
    testProcedureList: newTestProcedureList,
    orderedByList: newOrderedByList,
  };
};

export const filteredTestResults = (allResults, filterValues) => {
  const filteredResults = allResults.map((r) => {
    const result = r;
    result.isFiltered = false;

    if (!isDateInRange(filterValues.date, result.startDate)) {
      result.isFiltered = true;
      return result;
    }

    if (result.requestingPhysician !== filterValues.orderedBy && filterValues.orderedBy !== '') {
      result.isFiltered = true;
      return result;
    }

    for (let j = 0; j < result.labResultGroups.length; j += 1) {
      const group = result.labResultGroups[j];
      if (group.groupDisplayName === filterValues.testProcedure || filterValues.testProcedure === '') {
        result.isFiltered = false;
        return result;
      }
      result.isFiltered = true;
    }
    return result;
  });

  return filteredResults;
};
